import axios from 'axios';
import { AxiosResponse } from 'axios/index';

import { HSCAN_BACKEND_API_URL } from '../../env';

import { Case, GenerateHpacsLinkBody, HpacsLinkResponse } from './case';

export const requestShareToPatientCase = (sessionId: string) => {
  return axios.get<Case[]>(`${HSCAN_BACKEND_API_URL}/share-to-patient/case`, {
    headers: {
      SESSIONID: sessionId,
    },
  });
};

export const requestShareToPatientDicomImage = (
  imageId: string,
  sessionId: string,
) => {
  return axios.get<File>(
    `${HSCAN_BACKEND_API_URL}/share-to-patient/case/image/${imageId}`,
    {
      responseType: 'blob',
      headers: {
        SESSIONID: sessionId,
      },
    },
  );
};

/**
 * HPACS link 를 생성
 */
export const generateShareToPatientHpacsLinkId = (
  body: GenerateHpacsLinkBody,
  sessionId?: string,
) => {
  return axios.post<
    HpacsLinkResponse,
    AxiosResponse<HpacsLinkResponse>,
    GenerateHpacsLinkBody
  >(`${HSCAN_BACKEND_API_URL}/share-to-patient/link`, body, {
    headers: {
      SESSIONID: sessionId,
    },
  });
};

export const requestShareToPatientDownloadImage = (
  sseKey: string,
  caseIds: string[],
  sessionId: string,
) => {
  return axios.get<File>(
    `${HSCAN_BACKEND_API_URL}/share-to-patient/case/dicom/sse/${sseKey}`,
    {
      headers: {
        'Content-Type': 'application/zip',
        SESSIONID: sessionId,
      },
      responseType: 'blob',
      params: { ids: caseIds },
    },
  );
};

export interface RequestShareToPatientSaveRequest {
  uri: string;
}
export const requestShareToPatientSave = ({
  uri,
}: RequestShareToPatientSaveRequest) => {
  return axios.put<void>(
    `${HSCAN_BACKEND_API_URL}/share-to-patient/${uri}/save`,
  );
};
